package at.apa.statistictracker.db

import com.squareup.sqldelight.ColumnAdapter
import com.squareup.sqldelight.db.SqlDriver
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonElement

fun createDatabase(driver: SqlDriver) = StatisticTrackerDb(
    driver,
    StatisticPayloadTable.Adapter(
        payloadAdapter = jsonElementAdapter
    )
)

val jsonElementAdapter = object : ColumnAdapter<JsonElement, String> {
    override fun decode(databaseValue: String) = Json.parseToJsonElement(databaseValue)
    override fun encode(value: JsonElement) = Json.encodeToString(value)
}